import OptimizelyIconSVG from '@frontend/assets/Optimizely.svg';

type IconName = 'optimizely';

const CustomIconMap: Record<IconName, string> = {
  optimizely: OptimizelyIconSVG,
};

export function CustomIcon({
  name = 'optimizely',
  ...props
}: {
  name: IconName;
} & React.ImgHTMLAttributes<HTMLImageElement>) {
  if (!(name in CustomIconMap)) {
    return null;
  }
  return <img src={CustomIconMap[name]} alt={props.alt || name} {...props} />;
}
